import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ActionSheetController, ModalController } from "@ionic/angular";
import { ViewApplicationDetailModel } from "src/app/model/ViewApplicationDetailModel";
import { ViewApplicationService } from "src/app/services/view-application.service";
import { ViewPdfComponent } from "../../view-pdf/view-pdf.component";
import { AuditTrailService } from "src/app/audit-trail/audit-trail.service";
import { ProgressSpinnerComponent } from "src/app/progress-spinner/progress-spinner.component";
import { MatDialog } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { ViewProfileDocumentComponent } from "src/app/audit-trail/profile-details/view-profile-document/view-profile-document.component";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { SopConfigResponse } from "src/app/model/SopConfigResponse";
import { SopConfigResponseWrapperModel } from "src/app/model/SopConfigResponseWrapperModel";
import { UserResponseModel } from "src/app/model/UserResponseModel";
import { SopMasterModel } from "src/app/model/SopMasterModel";
import { MasterService } from "src/app/services/master.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ModalComponent } from "../modal/modal.component";
import { CorrigendumUploadModel } from "src/app/model/CorrigendumUploadModel";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { Page } from "src/app/model/Page";
import { PdfViewerModalComponent } from "../pdfViewerModal/pdfViewerModal.component";
import { escape } from "querystring";
import { ImageViewerModalComponent } from "../imageViewerModal/imgViewerModal.component";

@Component({
  selector: "app-corrigendum-form",
  templateUrl: "./corrigendum-form.component.html",
  styleUrls: ["./corrigendum-form.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CorrigendumApplicationFormComponent implements OnInit {
  data: CorrigendumUploadModel;
  applicationId: number;
  registrationId: number;
  isLoading: boolean = false;
  documents: CorrigendumUploadModel[];
  activeLang: string = "en";
  pageMode: string;
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  selectedFile: File;
  base64Response: string;
  corrigendumName: string;
  page: Page<CorrigendumUploadModel>;
  dataSource: MatTableDataSource<CorrigendumUploadModel> =
    new MatTableDataSource();
  pageSizeOptions: number[] = [10, 25, 100];
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  dataSourceLottery: MatTableDataSource<CorrigendumUploadModel> =
    new MatTableDataSource();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private viewCorrigendumService: ViewApplicationService,
    private masterService: MasterService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private modalCtrl: ModalController,
    private domSanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.applicationId = +params["applicationId"];

      this.isLoading = true;
      this.viewCorrigendumService
        .fetchCorrigendumView(this.applicationId)
        .subscribe(
          async (data: any) => {
            this.isLoading = false;
            if (data.status === "SUCCESS") {
              // console.log("data.status", data.status);

              this.data = data;
              this.registrationId = data.registrationId;
              // console.log("registrationId", this.registrationId);
              this.getCorrigendumDetails(data?.registrationId);

              // this.getDocuments(data?.panNumber);
            } else {
              this.viewCorrigendumService.errorToast(data.errorMessage);
            }
          },
          (error) => {
            this.isLoading = false;
            this.viewCorrigendumService.errorToast(
              error?.error?.errorMessage || error?.error?.message
            );
          }
        );
    });
    this.form = new FormGroup({
      sopName: new FormControl(null, [
        Validators.required,
        Validators.maxLength(255),
      ]),

      corrigendumLst: new FormArray([]),
    });
  }

  getCorrigendumDetails(registrationId: number) {
    this.isLoading = true;
    this.masterService.getCorrigendumDetails(this.registrationId).subscribe(
      (page) => {
        this.documents = page;
        this.isLoading = false;
      },
      (error) => {
        // console.log(error);
        this.isLoading = false;
      }
    );
  }

  viewDocument(document) {
    let image = document.corrigendumFileName;
    // console.log(image);
    if (image != undefined) {
      this.masterService
        .downloadFile(this.data?.registrationId, image)
        .subscribe(async ({ status, data, errorMessage }) => {
          if (status === "SUCCESS") {
            const fileType = this.getFileType(image);
            if (fileType === "pdf") {
              const modal = await this.modalCtrl.create({
                component: PdfViewerModalComponent,
                cssClass: "custom-modal1",
                componentProps: {
                  base64: data,
                  documentName: "Correspondence Pdf",
                  fileName:
                    "CORRESPONDENCE_PDF_" +
                    this.data?.registrationId +
                    this.data?.corrigendumFileName +
                    "_" +
                    new Date().getTime() +
                    ".pdf",
                },
              });
              modal.present();
            } else if (fileType === "image") {
              // Display image using another method or modal for images
              // Example: You might use a different modal or an image viewer component
              this.showImageModal(data);
            }
          } else {
            this.viewCorrigendumService.errorToast(errorMessage);
          }
        });
    }
  }

  getFileType(fileName: string): "pdf" | "image" | "unknown" {
    const extension = fileName.split(".").pop()?.toLowerCase();

    if (extension === "pdf") {
      return "pdf";
    } else if (["jpg", "jpeg", "png", "gif"].includes(extension)) {
      return "image";
    } else {
      return "unknown";
    }
  }

  async showImageModal(imageData: string) {
    // Implement your logic to display the image using a modal or other component
    // console.log("Displaying image:", imageData);
    const modal = await this.modalCtrl.create({
      component: ImageViewerModalComponent,
      cssClass: "custom-modal1",
      componentProps: {
        // Pass the image data to the image viewer modal
        imageData: this.domSanitizer.bypassSecurityTrustResourceUrl(
          `data:image/png;base64,${imageData}`
        ),
      },
    });
    modal.present();
  }

  openPdfViewerModal() {
    const dialogRef = this.dialog.open(PdfViewerModalComponent, {
      data: {
        base64Response: this.base64Response,
      },
      width: "50%",
      height: "80%",
    });
  }

  async editCorrigendum(key: number) {
    // this.router.navigate(["/secure", "corrigendum-upload", "modal", key]);
    const modal = await this.modalCtrl.create({
      component: ModalComponent,
      cssClass: "custom-modal1",
      componentProps: {
        key: key,
      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === "submit") {
      if (data.corrigendumName !== null && data.corrigendumName !== "") {
        this.saveCorrigendum(data);
      } else {
        this.masterService.errorToast("Please Fill Correspondence Name");
      }
    }
  }

  onFileSelect(event, i) {
    this.selectedFile = event.target.files[0];
  }

  onSubmit() {
    if (this.pageMode === "Edit") {
      // this.update();
      console.log("Update");
    } else {
      // this.save();
      console.log("Save");
    }
  }

  async successToast(msg) {
    await this._snackBar.open(msg, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open("Please Select Correspondence File", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }

  async openModal() {
    const modal = await this.modalCtrl.create({
      component: ModalComponent,
      cssClass: "custom-modal",
    });
    await modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === "submit") {
      if (data.corrigendumName !== null && data.corrigendumName !== "") {
        this.saveCorrigendum(data);
      } else {
        this.masterService.errorToast("Please Fill Correspondence Name");
      }
    }
  }

  saveCorrigendum(data) {
    let key = data.key;
    const corrigendumName = data.corrigendumName;
    const corrigendumFileName = data.corrigendumFileName;

    this.masterService
      .addcorigendumFile(
        key,
        this.registrationId,
        corrigendumName,
        corrigendumFileName
      )
      .subscribe(
        (resp) => {
          if (resp.status === "SUCCESS") {
            this.successToast("Correspondence saved successfully.");
            this.getCorrigendumDetails(this.registrationId);
          } else {
            this.errorToast(resp.errorMessage);
          }
        },
        (error) => {
          this.errorToast(error?.error?.message || error?.error?.errorMessage);
        }
      );
  }

  deactivate(key: number) {
    if (confirm("Do you want to De-Activate the Correspondence")) {
      this.masterService
        .deactiveCorrigendum(key, "N")
        .subscribe((data: any) => {
          if (data.status === "SUCCESS") {
            this.getCorrigendumDetails(this.registrationId);
            let selectedObj = this.page.content.find((o) => o.key === key);
            selectedObj.isActive = "N";
          } else {
            this.errorToast(data.errorMessage);
          }
        });
    }
  }

  activate(key: number) {
    if (confirm("Do you want to Activate the Correspondence")) {
      // console.log("Key for activate " + key);
      this.masterService
        .deactiveCorrigendum(key, "Y")
        .subscribe((data: any) => {
          if (data.status === "SUCCESS") {
            this.getCorrigendumDetails(this.registrationId);

            let selectedObj = this.page.content.find((o) => o.key === key);
            selectedObj.isActive = "Y";
          } else {
            this.errorToast(data.errorMessage);
          }
        });
    }
  }

  addCorrigendum() {
    let selectedCorrigendumFile: FormArray = this.form.get(
      "corrigendumLst"
    ) as FormArray;
    selectedCorrigendumFile.push(
      new FormGroup({
        key: new FormControl(null),
        corrigendumName: new FormControl(null, Validators.required),
        file: new FormControl(null, Validators.required),
      })
    );
  }

  get corrigendumDetails() {
    return this.form.get("corrigendumLst")["controls"];
  }
}
